export const CSS = {
	container: 'c-PhotomeasureButton',
};

export const Style = {
	[CSS.container]: {
		transform: 'rotate(-90deg)',
	},
};
